import classNames from "classnames";
import React from "react";
import { getSize } from "utils/functions";

const TableCol = ({ width, children, style = {}, className }) => {
  return (
    <div className={classNames("col", { [className]: !!className })} style={{ minWidth: getSize(width || 150), width: getSize(width || 150), flex: width ? "unset" : 1, height: "100%", fontSize: "12px", display: "flex", alignItems: "center", paddingInline: "10px", ...style }}>
      {children}
    </div>
  );
};

export default TableCol;
